export default __webpack_public_path__ + "static/media/06.49b7b5c2.jpg";